import { Subscribe } from '@react-rxjs/core';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Fallback } from '../../components/Fallback/Fallback';
import { ShellContent } from '../../components/Shell';
import { useLogbookReportList } from '../../services/logbook';
import { SubscribedReport } from './Report';
import { LogbookItem } from './views';
import styles from './Logbook.module.css';
import { SubscribedDownloadLogbook } from './DownloadLogbook';
import { useIsFeatureEnabled } from '../../services/features';

export const Logbook = () => {
  const { result, running } = useLogbookReportList();

  return (
    <ShellContent full>
      {running ? (
        <Fallback />
      ) : result ? (
        <div className={styles.list} data-testid="logbook-page">
          {result.map((props) => (
            <LogbookItem key={props.day} {...props} />
          ))}
        </div>
      ) : null}
    </ShellContent>
  );
};

export const LogbookFeature = () => {
  const enabled = useIsFeatureEnabled('LOGBOOK');

  if (!enabled) {
    <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path="/report/:id" element={<SubscribedReport />} />
      <Route path="/download/:id" element={<SubscribedDownloadLogbook />} />
      <Route
        path="*"
        element={
          <Subscribe fallback={<Fallback />}>
            <Logbook />
          </Subscribe>
        }
      />
    </Routes>
  );
};
